// Module
var code = `<div id="column-modal" class="modal-dialog" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<button type="button" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
			<h4 class="modal-title">Customize columns</h4>
		</div>
		<div class="modal-body">
			<div class="row">
				<div class="col-md-8">
					<input type="text" class="form-control" placeholder="Search columns..." aria-label="Search columns..." data-bind="textInput: search">
					<div id="available-columns">
						<!-- ko foreach: searchFields -->
						<!-- ko if: \$index() == 0 || \$root.isSystemField(\$root.searchFields()[\$index()-1]) != \$root.isSystemField(\$root.searchFields()[\$index()]) -->
						<h4 data-bind="text: \$index() == 0?'System fields':'Custom fields'"></h4>
						<!-- /ko -->
						<div class="form-check" data-bind="css:{ disabled: !\$data.removable }">
							<input class="form-check-input" type="checkbox" data-bind="checkedValue: \$data,  checkedInArray: \$root.selection, checkedComparer: function(a,b){ return a.id == b.id; }, attr:{ id: 'field' + \$index(), disabled: !\$data.removable }">
							<label class="form-check-label" data-bind="text: name, attr:{ for: 'field' + \$index() }"></label>
						</div>
						<!-- /ko -->
						<!-- ko if: searchFields().length == 0 -->
						<div class="empty">No columns found</div>
						<!-- /ko -->
					</div>
				</div>
				<div class="col-md-4">
					<h4>Selected columns (<span data-bind="text: selection().length"></span>)</h4>
					<div>
						<ul id="selected-columns" class="list-unstyled" data-bind="foreach: selection">
							<li>
								<span class="drag-handle">
									<i class="fa fa-drag"></i>
								</span>
								<span data-bind="text: name"></span>
								<!-- ko if: \$data.removable -->
								<a href="javascript:void(0);" class="remove" data-bind="click: function(obj, e){ \$root.clickedRemoveColumn(e) }" aria-label="Remove column"><i class="fa fa-times"></i></a>
								<!-- /ko -->
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
			<button type="button" class="btn btn-primary" data-bind="click: function(){ clickedApply(); }">
				Apply
			</button>
		</div>
	</div>
</div>
`;
// Exports
export default code;